import React, { useState, useEffect,useContext } from 'react';
import { Typography, Box } from '@mui/material';
import SettingsSidebar from './SettingsSidebar';
import SettingsMain from './SettingsMain';

const SettingsPage = () => {

  return (
    <div className="container">
    <Box sx={{ display: "flex", width: "100%" }}>
      <Box sx={{flex: 2, bgcolor: "grey.200", display: "flex", flexDirection: "column",height: "100%", overflow: "hidden",}}>
        <SettingsSidebar />
      </Box>
      <Box sx={{flex: 8, bgcolor: "#f9f9f9",display: "flex",flexDirection: "column",}}>
          <SettingsMain />
      </Box>
    </Box>
    </div>
  );
};

export default SettingsPage;

